import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.itemCategoryLevels)
      this.$itemCategoryLevels = options.itemCategoryLevels
    else if (options.parent && options.parent.$itemCategoryLevels)
      this.$itemCategoryLevels = options.parent.$itemCategoryLevels
  },
})

export default {
  async get(company) {
    const response = await http.get(`/item_category_levels/${company}`)
    return response.data
  },
}
